import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "@master/core/dist/core";
import { config } from "@config/config";
import { Observable } from "rxjs/internal/Observable";
import * as moment from 'moment';
import { map } from 'rxjs/internal/operators/map';
import { BaseService } from "./base.service";


@Injectable({
  providedIn: "root",
})
export class SlotsService extends BaseService{
  
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }
  
  /**
   * MYTA MADERUELO IMPLEMENTATION
   */
    public list(date: string, type: string, nslots: any): Observable<any> {

        const newDate = moment(new Date(date)).set({hour:0,minute:0,second:0,millisecond:0}).format();
        const url = this.getUrl() + `/slots/hours/date`
        const bodyParams = {
          date: newDate,
          type: type,
          nslots: nslots
        }
        return this.http.post(url, bodyParams).pipe(map(res => res));
        
  }
  /**
   * MYTA MADERUELO IMPLEMENTATION
   */
    public bookSlot(slot){
        const url = this.getUrl() + `/slots`
        return this.http.put(url, {slot});
    }

    public getMaxMinDateForSlots(transport: any): Promise<any>{
      const url = this.getUrl() + `/slots/maxMinDate`
        return this.http.post(url, transport).toPromise();
    }

}
